// Dependancies

import { createGlobalStyle } from 'styled-components';

export const CustomStyle = createGlobalStyle`
  .margin-left {
    margin-left: 0.2rem;
  }

  .flexed-nowrap {
    flex-wrap: nowrap;
  }

  .flexed-wrap {
    flex-wrap: wrap;
  }

  .flexed-space-between {
    justify-content: space-between;
  }

  .icon-item {
    margin-top: 0; 
    margin-bottom: 0;
  }
  .data-col {
    margin-left: 6px;
  }
  .card-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-divider {
    min-height: 0 !important;
  }
  .card-name {
    margin: 0;
    margin-bottom: 0.2rem;
  }

  .profile-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.2rem 0;
  
    color: var(--ion-color-primary-contrast);
    background-color: var(--ion-color-primary);
  
    .profile-name {
      color: var(--ion-color-primary-contrast);
      margin: 0;
    }
  }

  .default-page-wrapper {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
  }
  
  // Online/offline
  .online {
    ~.offline-sync {
      .offline-warning {
        visibility: hidden;
      }
    }
  }
  .offline {
    margin-bottom: 48px;
  }
  .offline-warning {
    position: absolute;
    bottom: 0;
    width: 100vw;
    z-index: -1;
  }
  
  // Sync/notsync
  .notsync {
    ~.offline-sync {
      .sync-warning {
        visibility: hidden;
      }
    }
  }
  .sync {
    margin-bottom: 48px;
  }
  .sync-warning {
    position: absolute;
    bottom: 0;
    width: 100vw;
    z-index: -1;
  }

  // offline+sync
  .offline.sync {
    margin-bottom: 96px;

    ~.offline-sync {
      .offline-warning {
        bottom: 0;
      }
      .sync-warning {
        bottom: 48px;
      }
    }
  }
  
  /* Clocking card */
  .clocking-card {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .time-duration {
      display: inline-block;
      font-size: 250%;
  
      &.time-duration-seconds {
      vertical-align: top;
      font-size: 125%;
      margin-left: 3px;
      min-width: 20px;
      max-width: 20px;
      text-align: left;
      }
  }
  .simple .time-duration {
      &.time-duration-seconds {
      font-size: 100%;
      }
      font-size: 200%;
  }
  .small .time-duration {
      &.time-duration-seconds {
      font-size: 50%;
      }
      font-size: 100%;
  }
  .title-icon {
      margin-right: 10px;
  }

  /* Datetime component */
  ion-datetime {
    color: var(--ion-text-color)
  }
`;
